import ITask from './ITask';
import { Alpha, OverlayFadeIn } from '../../System/Animation/Clip';
import { StartAnimationClip } from '../../System/Animation/AnimationHelper';
import Game from '../../Game';
import WorldSystem from '../../System/World/WorldSystem';
import GameObject, { GameObjectEvent } from '../../GameObject/GameObject';
import Element from '../../Prototype/UI/Element';
import { TextAlignment } from '../../Prototype/UI/TextAlignment';
import Overlay from '../../Prototype/UI/Overlay';
import { AnimationClipEvent } from '../../System/Animation/AnimationClip';
import { RenderSystemEvent } from '../../System/Render/RenderSystem';
import TransformComponent from '../../Component/Transform';
import Point from '../Point';
import { PlayerActions } from '../../State/Player/PlayerActions';
import { FTUXType } from "../../Player/PlayerProperty/Progress/FTUXType";
import { PetId } from '../../Constants/Pets';
import { PetAnimations } from '../Helpers/Pets/PetAnimations';
import { PetsHelper } from '../Helpers/Pets/PetsHelper';
import { applyDefaultButtonAnimation } from '../../System/UI/UIHelper';
import { GameActions } from '../../State/Game/GameActions';
import LevelNode from '../../Prototype/World/LevelNode/LevelNode';

const PET_CONTAINER = 'pet_container';
export default class PetFTUXTask implements ITask<WorldSystem> {
    private readonly petLevel: number;
    private readonly petId: PetId;

    constructor(
        petLevel: number,
        petId: PetId,
    ) {
        this.petLevel = petLevel;
        this.petId = petId;
    }

    public *execute(system: WorldSystem): IterableIterator<any> {
        let closePetFTUX: boolean = false;
        const toggleClose = () => {
            closePetFTUX = true;
        }

        const worldSystem = Game.scene.getActiveScene().getSystem(WorldSystem);
        const pet = worldSystem.pet;
        pet.setPetId(this.petId);

        const overlay: Overlay = GameObject.Instantiate(Overlay, {
            name: 'pet_ftux_overlay',
            preventInteraction: true,
            anchors: [0.5, 0.5, 0.5, 0.5],
            alpha: 0,
            color: [0, 0, 0, 225],
        });

        worldSystem.animator.addChild(overlay);
        worldSystem.animator.scene.emit(
            RenderSystemEvent.BRING_TO_FRONT,
            worldSystem.animator
        );

        addListener(overlay);

        const background = GameObject.Instantiate(Element, {
            name: 'background',
            layout: {
                anchors: [0.23, 0.55, 0.23, 0.55],
                pivot: [0.5, 0.5],
                offsets: [0, 0, 0, 0],
                scale: [1, 1],
                constrains: {
                    heightMin: 300,
                    heightMax: 300,
                    widthMin: 600,
                    widthMax: 600,
                },
            },
            components: [
                {
                    type: 'nineslice',
                    data: {
                        cacheKey: 'mission_board',
                        offset: [80, 80, 80, 80],
                    },
                },
            ],
            children: [
                {
                    name: 'pet_gift',
                    layout: {
                        anchors: [0.22, 0.5, 0.22, 0.5],
                        pivot: [0.5, 0.5],
                        offsets: [0, 0, 0, 0],
                        scale: [0.9, 0.9],
                    },
                    components: [
                        {
                            type: 'image',
                            data: {
                                cacheKey: 'pet_gift_small',
                            },
                        },
                    ],
                },
                {
                    name: 'text',
                    layout: {
                        anchors: [0.68, 0.715, 0.68, 0.715],
                        pivot: [0.5, 0.5],
                        offsets: [0, 0, 0, 0],
                        constrains: {
                            heightMin: 300,
                            heightMax: 300,
                            widthMin: 350,
                            widthMax: 350,
                        },
                    },
                    components: [
                        {
                            type: 'text',
                            data: {
                                textLocalizationKey: `${PetId.Charly}PetUnlockFTUX`,
                                bounds: [300, 180],
                                wordWrap: true,
                                wordWrapWidth: 300,
                                style: 'PetUnlockedFTUX',
                                align: TextAlignment.CENTER,
                            },
                        },
                    ],
                },
                {
                    name: "node",
                    layout: {
                        anchors: [1.1, 0.75, 1.1, 0.75],
                        pivot: [0.5, 0.5],
                        offsets: [0, 0, 0, 0],
                    },
                    components: [
                        {
                            type: 'image',
                            data: {
                                cacheKey: 'node_current',
                            },
                        },
                    ],
                    children: [
                        {
                            name: PET_CONTAINER,
                            layout: {
                                anchors: [0.5, 0.5, 0.5, 0.5],
                                pivot: [0.5, 0.5],
                                offsets: [0, 0, 0, 0],
                                constrains: {
                                    heightMin: 1,
                                    heightMax: 1,
                                    widthMin: 1,
                                    widthMax: 1,
                                }
                            },
                        }
                    ]
                },
            ],
        });

        const continueButtonBG = GameObject.Instantiate(Element, {
            name: 'continue_button_bg',
            layout: {
                anchors: [0.7, 0.65, 0.7, 0.65],
                pivot: [0.5, 0.5],
                offsets: [0, 0, 0, 0],
                scale: [1, 1],
            },
            components: [
                {
                    type: 'image',
                    data: {
                        cacheKey: 'blank',
                    },
                },
            ],
            children: [
                {
                    name: 'continue_button',
                    layout: {
                        anchors: [0.5, 0.5, 0.5, 0.5],
                        pivot: [0.5, 0.5],
                        offsets: [0, 70, 0, 70],
                        scale: [0.85, 0.85],
                    },
                    components: [
                        {
                            type: 'image',
                            data: {
                                cacheKey: 'button_medium_green',
                            },
                        },
                        {
                            type: 'input',
                            data: {
                                buttonMode: true,
                                enabled: true,
                            },
                        },
                    ],
                    children: [
                        {
                            name: 'text',
                            layout: {
                                anchors: [0.5, 0.5, 0.5, 0.5],
                                pivot: [0.5, 0.5],
                                offsets: [0, 3, 0, 3],
                                scale: [1, 1],
                            },
                            components: [
                                {
                                    type: 'text',
                                    data: {
                                        textLocalizationKey: 'Continue',
                                        style: 'popup.green_btn',
                                        bounds: [230, 100],
                                    },
                                },
                            ],
                        },
                    ],
                },
            ],
        });
        const button = continueButtonBG.find("continue_button");
        applyDefaultButtonAnimation(button);
        addListener(button);

        overlay.addChild(background);
        overlay.addChild(continueButtonBG);

        StartAnimationClip(new OverlayFadeIn(overlay));

        const petContainer = background.findChildByName(PET_CONTAINER);
        const levelNode: LevelNode | undefined = worldSystem.getLevelNode(this.petLevel);

        const petData = PetsHelper.getPetData(this.petId);
        const petTransform = pet.getComponent(TransformComponent);
        const petParent = pet.parent;

        petContainer.addChild(pet);
        petTransform.scale.copy(petData.nodeScale);
        petTransform.position.copy(petData.positionOffset);
        pet.initialized.then(pet.getPlayAnimation(PetAnimations.IDLE));

        StartAnimationClip(
            new Alpha(background, {
                startAlpha: 0,
                endAlpha: 1,
                duration: 450,
            })
        );

        StartAnimationClip(
            new Alpha(overlay, {
                startAlpha: 0,
                endAlpha: 1,
                duration: 450,
            })
        );

        while (!closePetFTUX) {
            yield;
        }

        StartAnimationClip(
            new Alpha(overlay, {
                startAlpha: 1,
                endAlpha: 0,
                duration: 450,
            }).on(AnimationClipEvent.DESTROY, () => {
                removeListener(overlay);
                removeListener(button)
                petParent.addChild(pet);

                if (levelNode) {
                    petTransform.position.copy(
                        Point.add(
                            levelNode.getPetPosition(),
                            petData.positionOffset,
                        ),
                    );
                }

                overlay.destroy();
                GameActions.loadMyPetMiniGame({});
            })
        );

        PlayerActions.setFTUXUnlocks([FTUXType.PET_UNLOCK]);

        return;

        function addListener(gameObject: GameObject) {
            gameObject.on(GameObjectEvent.POINTER_UP,  toggleClose);
        }

        function removeListener(gameObject: GameObject) {
            gameObject.off(GameObjectEvent.POINTER_UP, toggleClose);
        }

    }
}
